const TagPickerErrors = {
  paste: "There was an error while trying to paste values  ",
  duplicates: "Duplicate value(s) omitted:",
  invalid: "Invalid value(s) omitted:"
};
export {
  TagPickerErrors
};
//# sourceMappingURL=TagPicker.constants.js.map
